import { Drawer } from '@mantine/core';
import { Message } from '../types';
import { useComposeEmail } from '../hooks/useComposeEmail';
import { ComposeEmailForm } from '../forms/ComposeEmailForm';

interface ComposeEmailDrawerProps {
    opened: boolean;
    onClose: () => void;
    aliasId?: string;
    replyTo?: Message;
    replyAll?: boolean;
    forwardMessage?: Message;
}

export const ComposeEmailDrawer = ({ opened, onClose, aliasId, replyTo, replyAll, forwardMessage }: ComposeEmailDrawerProps) => {
    const {
        initialValues,
        aliasOptions,
        handleSubmit,
        generateTestMessage,
        title,
    } = useComposeEmail(opened, aliasId, replyTo, replyAll, forwardMessage);

    const onSubmit = async (values: typeof initialValues) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer opened={opened} onClose={onClose} title={title} position="right" size="xl">
            <ComposeEmailForm
                initialValues={initialValues}
                aliasOptions={aliasOptions}
                onSubmit={onSubmit}
                generateTestMessage={generateTestMessage}
            />
        </Drawer>
    );
};
